import { ListSortDirection } from 'src/api/requests'

export const getOrderingDirection = (val: string) => {
  return val.includes('-')
    ? ListSortDirection.DESCENDING
    : ListSortDirection.ASCENDING
}

export const normalizeOrdering = (val: string) => {
  return val.replaceAll('-', '')
}
